import getEnvironDomain from "./getEnvironDomain";

const headerApiUrlsFallback = (urlString, serviceName) => {
  const webapiRegexp = /webapi/;
  return webapiRegexp.test(urlString)
    ? urlString
    : `//${getEnvironDomain()}/webapi/${serviceName}`;
};

export default headerApiUrlsFallback;
